class MFooter extends HTMLElement {
  constructor() {
    super();
    this._auraFooterBound = false;
    this.init();
  }

  init() {
    const mobileAccordion = this.querySelector(".m-footer--accordion");
    const mobileStickyBar = document.querySelector(".m-mobile-sticky-bar");

    if (mobileAccordion) {
      const initAccordion = () => {
        if (MinimogTheme.config.mqlMobile) {
          this.acc = new MinimogLibs.Accordion(mobileAccordion, { presetContentHeight: true, onload: true });
          window.setTimeout(() => this.initAuraMobileAccordion(), 120);
          window.setTimeout(() => this.syncAuraMobileAccordion(), 500);
        }
      };

      initAccordion();

      document.addEventListener("matchMobile", () => {
        initAccordion();
      });

      document.addEventListener("unmatchMobile", () => {
        this.clearAuraMobileAccordion();
      });
    }

    // Set mobile stickybar height
    if (mobileStickyBar) {
      const setStickyHeight = () => {
        document.documentElement.style.setProperty("--mobile-sticky-bar-height", `${mobileStickyBar.offsetHeight}px`);
      };
      setStickyHeight();
      document.addEventListener("matchMobile", setStickyHeight);
      document.addEventListener("unmatchMobile", setStickyHeight);
    }

    window.addEventListener("load", () => this.syncAuraMobileAccordion());
  }

  isAuraMobile() {
    return window.matchMedia("(max-width: 767px)").matches;
  }

  initAuraMobileAccordion() {
    if (this._auraFooterBound || !this.isAuraMobile()) return;
    this._auraFooterBound = true;

    const buttons = this.querySelectorAll(".m-footer--block.m-accordion--item .m-accordion--item-button");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        window.setTimeout(() => {
          const item = button.closest(".m-footer--block.m-accordion--item");
          if (!item) return;

          const singleOpen = String(this.dataset.auraMobileSingleAccordion) !== "false";
          if (singleOpen && item.classList.contains("open")) {
            this.querySelectorAll(".m-footer--block.m-accordion--item.open").forEach((other) => {
              if (other !== item) this.closeAuraItem(other);
            });
          }

          this.syncAuraMobileAccordion();
        }, 90);
      });
    });

    this.syncAuraMobileAccordion();
  }

  syncAuraMobileAccordion() {
    if (!this.isAuraMobile()) return;

    this.querySelectorAll(".m-footer--block.m-accordion--item").forEach((item) => {
      const content = item.querySelector(".m-accordion--item-content");
      if (!content) return;

      if (item.classList.contains("open")) {
        content.style.opacity = "1";
        content.style.visibility = "visible";
        content.style.maxHeight = `${Math.max(content.scrollHeight + 80, 240)}px`;
      } else {
        content.style.maxHeight = "0px";
      }
    });
  }

  closeAuraItem(item) {
    item.classList.remove("open");
    const content = item.querySelector(".m-accordion--item-content");
    if (content) {
      content.style.maxHeight = "0px";
      content.style.opacity = "0";
      content.style.overflow = "hidden";
    }
  }

  clearAuraMobileAccordion() {
    this._auraFooterBound = false;
    this.querySelectorAll(".m-accordion--item-content").forEach((content) => {
      content.style.maxHeight = "";
      content.style.opacity = "";
      content.style.visibility = "";
      content.style.overflow = "";
    });
  }
}

customElements.define("m-footer", MFooter);
